/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied from antd/components/list/item.tsx
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
import React from 'react';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
import { Col } from '../grid';
import { ListContext } from 'antd/es/list';
import { ListItemProps } from 'antd/es/list/Item';
import { cloneElement } from '../_util/reactNode';
import { Icon } from '../icon';
const Meta = ({ prefixCls: customizePrefixCls, className, avatar, title, description, footnote, ...others }) => {
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('list', customizePrefixCls);
    const classString = classNames(`${prefixCls}-item-meta`, className);
    const content = (React.createElement("div", { className: `${prefixCls}-item-meta-content` },
        title && React.createElement("h4", { className: `${prefixCls}-item-meta-title` }, title),
        description && React.createElement("div", { className: `${prefixCls}-item-meta-description` }, description),
        footnote && React.createElement("div", { className: `${prefixCls}-item-meta-footnote` }, footnote)));
    return (React.createElement("div", { ...others, className: classString },
        avatar && React.createElement("div", { className: `${prefixCls}-item-meta-avatar` }, avatar),
        (title || description || footnote) && content));
};
Meta.displayName = 'Meta';
const Item = ({ prefixCls: customizePrefixCls, children, actions, extra, className, colStyle, ...others }) => {
    const { grid, itemLayout } = React.useContext(ListContext);
    const { getPrefixCls } = React.useContext(ConfigContext);
    let hasMetaChildrean = false;
    React.Children.map(children, (child) => {
        if (child.type === Meta) {
            hasMetaChildrean = true;
        }
    });
    const isItemContainsTextNodeAndNotSingular = () => {
        let result;
        // @ts-ignore
        React.Children.forEach(children, (element) => {
            if (typeof element === 'string') {
                result = true;
            }
        });
        return result && React.Children.count(children) > 1;
    };
    const isFlexMode = () => {
        if (itemLayout === 'vertical') {
            return !!extra;
        }
        return !isItemContainsTextNodeAndNotSingular();
    };
    const prefixCls = getPrefixCls('list', customizePrefixCls);
    const actionsContent = actions && actions.length > 0 && (React.createElement("ul", { className: `${prefixCls}-item-action`, key: 'actions' }, actions.map((action, i) => (
    // eslint-disable-next-line react/no-array-index-key
    React.createElement("li", { key: `${prefixCls}-item-action-${i}` },
        action,
        i !== actions.length - 1 && React.createElement(Icon, { type: 'slash', className: `${prefixCls}-item-actions-split` }))))));
    const Element = grid ? 'div' : 'li';
    const itemChildren = (React.createElement(Element, { ...others, className: classNames(`${prefixCls}-item`, {
            [`${prefixCls}-item-no-flex`]: !isFlexMode(),
            [`${prefixCls}-item-with-meta`]: hasMetaChildrean
        }, className) }, itemLayout === 'vertical' && !!extra
        ? [
            !!extra || !!actionsContent ? (React.createElement("div", { className: `${prefixCls}-item-extra`, key: 'extra' }, extra)) : null,
            React.createElement("div", { className: `${prefixCls}-item-main`, key: 'content' },
                children,
                actionsContent)
        ]
        : [cloneElement(extra, { key: 'extra' }), children, actionsContent]));
    return grid ? (React.createElement(Col, { flex: 1, style: colStyle }, itemChildren)) : (itemChildren);
};
Item.Meta = Meta;
export { Meta };
// const ConfiguredItem = withConfigProvider(Item);
// export { ConfiguredItem as Item };
// export default ConfiguredItem;
export default Item;
